import { EXTERNAL_LINKS } from '@/content/externalLinks';

export interface InstallPluginResult {
  url: string;
  name: string;
  description: string;
}

export const executeInstallPlugin = (): InstallPluginResult => ({
  url: EXTERNAL_LINKS.figmaPlugin,
  name: 'Color Scales I/O',
  description:
    'Figma plugin for contrast-first color scales with WCAG and APCA support, design token export, and Leonardo-powered generation.',
});
